export function localePlugin(locale, _mapStoreLocale = mapStoreLocale) {
  const appTarget = "";
  return function localePlugin2({ opContext }) {
    opContext.headers["Content-Language"] = locale;
    opContext.headers.Store = `${appTarget}${_mapStoreLocale(locale)}`;
  };
}
